import { siyanda_platinum_dashboard_ids } from "@/config/dashboardIds";

export const property_names = [
  "Spud Shaft",
  // "4 South",
  "Declines",
  "Richard",
  "Portfolio Property"
];

const portfolio_property_name = "Portfolio Property";

const service_provider_list = [
  { name: "City Power", category: "Electricity", phone: "086 000 7788", icon: "bi bi-lightning-charge-fill" },
  { name: "Johannesburg Water", category: "Water & Sanitation", phone: "011 688 2500", icon: "bi bi-droplet-fill" },
  { name: "Fidelity Services", category: "Security Response", phone: "086 013 4354", icon: "bi bi-shield-lock-fill" },
  { name: "Vuma", category: "Connectivity", phone: "087 820 9000", icon: "bi bi-wifi" },
  { name: "Facilities Desk", category: "Maintenance", phone: "010 500 3000", icon: "bi bi-tools" }
];

const property_profiles = [
  {
    id: siyanda_platinum_dashboard_ids.spud_shaft,
    name: "Spud Shaft",
    is_live: true,
    description: "Mining shaft",
    size: "2,850 sqm",
    occupancy: "99%",
    trend: "+4.2%",
    efficiency: "Operational Efficiency 94%",
    coordinates: { lat: -26.1076, lng: 28.0567 },
    manager: "Naledi Mokoena",
    phone: "011 555 0101",
    email: "spud.shaft@example.com",
    crimeIndex: "Low"
  },
  // {
  //   id: siyanda_platinum_dashboard_ids.four_south,
  //   name: "4 South",
  //   is_live: true,
  //   description: "Mining shaft",
  //   size: "1,120 sqm",
  //   occupancy: "96%",
  //   trend: "+3.1%",
  //   efficiency: "Operational Uptime 96%",
  //   coordinates: { lat: -26.1082, lng: 28.0579 },
  //   manager: "Sibusiso Khumalo",
  //   phone: "011 555 0102",
  //   email: "4south@example.com",
  //   crimeIndex: "Medium"
  // },
  {
    id: siyanda_platinum_dashboard_ids.four_b_and_four_south,
    name: "Declines",
    is_live: true,
    description: "Mining shaft",
    size: "3,430 sqm",
    occupancy: "100%",
    trend: "+5.8%",
    efficiency: "Resident Satisfaction 91%",
    coordinates: { lat: -26.1091, lng: 28.0556 },
    manager: "Ayesha Patel",
    phone: "011 555 0103",
    email: "4b@example.com",
    crimeIndex: "Low"
  },
  {
    id: siyanda_platinum_dashboard_ids.richard,
    name: "Richard",
    is_live: true,
    description: "Mining shaft",
    size: "380 sqm",
    occupancy: "93%",
    trend: "+2.4%",
    efficiency: "Facilities SLA 87%",
    coordinates: { lat: -26.1069, lng: 28.0584 },
    manager: "Lerato Dlamini",
    phone: "011 555 0104",
    email: "richard@example.com",
    crimeIndex: "Low"
  }
];

function get_crime_stats(profile, index) {
  return ({
    precinct: `${profile.name} Property Precinct`,
    stationContact: `011 555 02${String(index + 1).padStart(2, "0")}`,
    crimeIndex: profile.crimeIndex,
    periodIncrease: `${index % 2 === 0 ? "4% decrease" : "3% increase"} from prior quarter`,
    incidentSummary: [
      { category: "Property Crime", count: 3 + index, trend: index % 2 === 0 ? "-6%" : "+4%" },
      { category: "Theft from Vehicle", count: 1 + (index % 4), trend: "-2%" },
      { category: "Assault", count: index % 3, trend: "0%" },
      { category: "Burglary", count: 1 + (index % 2), trend: "-8%" }
    ],
    lastUpdated: "2026-06-01",
    communityForumLink: "https://example.com/community-safety"
  });
}

function get_team_contacts(profile) {
  return [
    {
      full_name: profile.manager,
      role: "Property Manager",
      status: "on-site",
      hours: "Mon-Fri 8am-5pm",
      phone: profile.phone,
      email: profile.email,
      address: `${profile.name} management office`,
      website: "N/A"
    },
    {
      full_name: "Security Control Room",
      role: "Security Manager",
      status: "on-site",
      hours: "24/7",
      phone: "011 555 0199",
      email: "security@example.com",
      address: `${profile.name} security office`,
      website: "N/A"
    },
    {
      full_name: "Facilities Desk",
      role: "Facilities Manager",
      status: "break",
      hours: "Mon-Sat 7am-7pm",
      phone: "011 555 0188",
      email: "facilities@example.com",
      address: `${profile.name} facilities office`,
      website: "N/A"
    }
  ];
}

function get_recent_documents(profile) {
  return [
    { title: `${profile.name} Monthly Operations Report`, updated: "2 hours ago", size: "2.4 MB", icon: "bi bi-file-earmark-pdf-fill" },
    { title: `${profile.name} Utility Consumption Snapshot`, updated: "yesterday", size: "1.8 MB", icon: "bi bi-file-earmark-excel-fill" },
    { title: `${profile.name} Incident Register`, updated: "3 days ago", size: "856 KB", icon: "bi bi-file-earmark-word-fill" },
    { title: `${profile.name} Maintenance Schedule`, updated: "1 week ago", size: "3.2 MB", icon: "bi bi-file-earmark-pdf-fill" }
  ];
}

function get_shift_schedule() {
  return [
    { label: "Opening Shift", time: "07:00 - 15:00", personnel: 8 },
    { label: "Trading Shift", time: "09:00 - 17:00", personnel: 14 },
    { label: "Closing Shift", time: "13:00 - 21:00", personnel: 10 },
    { label: "Security Patrol", time: "18:00 - 06:00", personnel: 4 }
  ];
}

function get_quick_actions(profile) {
  return [
    { label: "Log maintenance issue", icon: "bi bi-tools", variant: "primary" },
    { label: `Contact ${profile.manager}`, icon: "bi bi-telephone-fill", variant: "secondary" },
    { label: "Download latest report", icon: "bi bi-download", variant: "secondary" }
  ];
}

function get_tile_cards(profile) {
  return [
    {
      id: `${profile.name}-management-contacts`,
      title: "On-Site Team Members",
      type: "details",
      contacts: get_team_contacts(profile)
    },
    {
      id: `${profile.name}-emergency-contacts-map`,
      title: "Emergency Contacts & Location",
      type: "emergency-map",
      locationName: profile.name,
      coordinates: profile.coordinates
    },
    {
      id: `${profile.name}-service-providers`,
      title: "Service Providers",
      type: "service-providers",
      providers: service_provider_list
    }
  ];
}

function get_property_tile(profile, index) {
  return ({
    id: profile.id || `${profile.name}${profile.is_live ? " (Live)" : ""}`,
    shaft_id: profile.id || "",
    title: profile.name,
    is_live: Boolean(profile.is_live),
    stats: profile.efficiency,
    description: profile.description,
    trend: profile.trend,
    dashboardId: profile.dashboardId || profile.id,
    coordinates: profile.coordinates,
    propertyOverview: {
      title: profile.name,
      size: profile.size,
      occupancy: profile.occupancy,
      description: profile.description,
      total_centres: property_profiles.length
    },
    crimeStats: get_crime_stats(profile, index),
    teamContacts: get_team_contacts(profile),
    recentDocuments: get_recent_documents(profile),
    shiftSchedule: get_shift_schedule(profile),
    quickActions: get_quick_actions(profile),
    tileCards: get_tile_cards(profile)
  });
}

export default function getTilesConfiguration() {
  return property_profiles
    .filter((profile) => profile.name !== portfolio_property_name)
    .map((profile, index) => get_property_tile(profile, index));
}
